import { FC, useCallback, useMemo } from 'react'

import { Dropdown, Size } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useUpdateQueryParams } from '../../../../../../lib/adapters/next-routing-service/useUpdateQueryParam'
import { DropdownWrapper } from '../styles'

export const DropdownSection: FC<{
  isInvalid?: boolean
  sizes: Size[]
  selection: Size['shorthand'] | undefined
}> = ({ isInvalid, sizes, selection }) => {
  const updateQueryParams = useUpdateQueryParams()
  const { giftCard: strings } = useTranslation()

  const sortedGiftCards = sizes
    .map(i => Number(i.shorthand.substr(1)))
    .sort((x, y) => x - y)
    .map(i => '$'.concat(i.toString()))

  const soldOutByShorthand: Record<string, boolean> = useMemo(
    () =>
      sizes.reduce(
        (accum, size) => ({
          ...accum,
          [size.shorthand]: size.soldOut,
        }),
        {}
      ),
    [sizes]
  )

  const renderDropdownOptionSoldOutText = useCallback(
    (sizeShorthand: string) =>
      soldOutByShorthand[sizeShorthand]
        ? `${sizeShorthand} ${strings.dropdownSoldOutOptionText}`
        : sizeShorthand,
    [soldOutByShorthand, strings.dropdownSoldOutOptionText]
  )

  return (
    <DropdownWrapper>
      <Dropdown
        hidePlaceholderAsOption
        isInvalid={isInvalid}
        onChange={size => {
          updateQueryParams({
            size,
          })
        }}
        options={sortedGiftCards}
        placeholderText='$100'
        renderOptionText={renderDropdownOptionSoldOutText}
        selection={selection}
      />
    </DropdownWrapper>
  )
}
